export const LEGAL_JURISDICTION = "ZA";

export const LEGAL_DOCUMENTS = {
  terms: {
    type: "terms",
    version: "2026-07-30",
    locale: "en-ZA",
    title: "Terms of Service",
    summary: "The rules for using Band-Joe and its marketplace features.",
    sections: [
      ["1. About these terms", [
        "These Terms of Service form an agreement between you and Band-Joe when you access or use the Band-Joe website, accounts, profiles, gig board, messaging, booking and related services.",
        "You must be at least 18 years old and able to enter into a binding agreement. If you use Band-Joe for an organisation, you confirm that you are authorised to bind it.",
      ]],
      ["2. Accounts and acceptable use", [
        "Provide accurate information, keep your login details secure and notify us if you believe your account has been compromised. You are responsible for activity performed through your account.",
        "Do not impersonate others, scrape or disrupt the service, introduce malicious code, evade access controls, send spam, infringe rights, or publish unlawful, deceptive, abusive or discriminatory content.",
      ]],
      ["3. Profiles, content and licences", [
        "You retain ownership of content you submit. You give Band-Joe a non-exclusive, worldwide, royalty-free licence to host, reproduce, format and display that content only as needed to operate, improve and promote the service.",
        "You confirm that you have the rights and permissions needed for anything you upload. We may remove content or restrict accounts where reasonably necessary to protect users, comply with law or enforce these terms.",
      ]],
      ["4. Gigs, bookings and payments", [
        "Band-Joe helps artists, venues and studios discover and communicate with one another. Unless expressly stated otherwise, Band-Joe is not a party to agreements made between users and does not guarantee attendance, payment, performance quality or the accuracy of a listing.",
        "Users must agree their own fees, taxes, deposits, cancellation rules, safety requirements and performance or service terms. Review the other party and the final terms before committing.",
      ]],
      ["5. Fees and third-party services", [
        "Any paid Band-Joe feature will show its price and billing terms before purchase. Ticketing, maps, payment providers and linked websites may have separate terms and privacy practices.",
      ]],
      ["6. Suspension and termination", [
        "You may stop using the service at any time. We may suspend or terminate access for a material or repeated breach, unlawful conduct, security risk or non-payment, and will give notice where reasonably possible.",
      ]],
      ["7. Disclaimers and liability", [
        "The service is provided on an “as available” basis. To the extent permitted by law, Band-Joe does not give warranties that the service will always be uninterrupted, error-free or suitable for a particular engagement.",
        "Nothing in these terms excludes liability that cannot lawfully be excluded. Otherwise, Band-Joe is not liable for indirect or consequential loss, or for disputes and conduct between users.",
      ]],
      ["8. Changes, law and contact", [
        "We may update these terms. Material changes will be communicated reasonably in advance and a new version will apply prospectively. Continued use after the effective date means you accept the updated terms.",
        "These terms are governed by the laws of South Africa. South African courts have jurisdiction, without limiting any consumer rights that apply where you live. Questions may be sent to legal@band-joe.com.",
      ]],
    ],
  },
  privacy: {
    type: "privacy",
    version: "2026-07-30",
    locale: "en-ZA",
    title: "Privacy Policy",
    summary: "How Band-Joe collects, uses, shares and protects personal information.",
    sections: [
      ["1. Scope and responsible party", [
        "This policy applies to the Band-Joe website and services. Band-Joe is the responsible party for personal information processed to provide the platform. Privacy questions and requests may be sent to info@bandjoe.com",
      ]],
      ["2. Information we collect", [
        "We collect account and profile information such as your display name, email address, role, city, organisation details, profile content and login credentials. Passwords should be stored as secure hashes, not readable text.",
        "We also process messages, gig and booking activity, reviews, support correspondence, preferences, consent records, and technical information such as device, browser, IP address, security events and service usage.",
        "Precise location is collected only after you choose to share it. Public contact details and profile content are displayed only according to the choices available when you provide them.",
      ]],
      ["3. Why we use information", [
        "We use information to create and secure accounts, operate discovery and marketplace features, deliver messages, personalise regional results, provide support, prevent abuse, comply with law and improve service reliability.",
        "Our legal bases may include performing our agreement with you, your consent, compliance with legal obligations and legitimate interests such as service security and improvement. You may withdraw consent where processing depends on it.",
      ]],
      ["4. Sharing and international processing", [
        "Information may be shared with people you choose to interact with, the public when you publish a profile or listing, service providers that host or support Band-Joe, and authorities where legally required. We do not sell personal information.",
        "Providers may process information outside your country. Where required, we use appropriate contractual or legal safeguards for cross-border transfers.",
      ]],
      ["5. Retention and security", [
        "We retain information only as long as needed for the purposes described, including account operation, dispute resolution, fraud prevention and legal obligations. Retention periods vary by record type.",
        "We use reasonable organisational and technical safeguards, but no online service can guarantee absolute security. Please use a strong, unique password and report suspected compromise promptly.",
      ]],
      ["6. Your choices and rights", [
        "Depending on applicable law, you may ask to access, correct, delete, restrict or object to processing of your personal information, request portability, or complain to a data protection authority. In South Africa, you may complain to the Information Regulator.",
        "You can change browser location permission at any time. Marketing communications, if offered, will include an unsubscribe method. Essential service and security messages cannot always be disabled while an account remains active.",
      ]],
      ["7. Cookies, children and changes", [
        "Band-Joe may use essential storage for sessions, security and preferences. Optional analytics or marketing technologies should be used only with the consent required by law.",
        "Band-Joe is not intended for children under 18. We may update this policy and will identify the current version and effective date on this page, with additional notice for material changes.",
      ]],
    ],
  },
};

export function getLegalDocument(type) {
  return LEGAL_DOCUMENTS[type] || null;
}

export function buildLegalConsent(locale, acceptedAt = new Date().toISOString()) {
  return {
    accepted: true,
    acceptedAt,
    jurisdiction: LEGAL_JURISDICTION,
    interfaceLocale: locale,
    terms: {
      version: LEGAL_DOCUMENTS.terms.version,
      locale: LEGAL_DOCUMENTS.terms.locale,
    },
    privacy: {
      version: LEGAL_DOCUMENTS.privacy.version,
      locale: LEGAL_DOCUMENTS.privacy.locale,
    },
  };
}
